export const contactBillingCopy = {
  title: 'Cobranças do contato',
  detailsTitle: 'Vínculos e cobranças bancárias',
  detailsDescription:
    'Cadastre os códigos de cliente e assinatura para consultar os boletos na integração da empresa.',
  unavailable:
    'Um administrador precisa ativar e validar a integração do banco e a consulta de cobranças em Configurações → Integrações. O Asaas é o primeiro banco disponível.',
  link: 'Vínculo bancário',
  customer: 'Cliente no banco:',
  subscription: 'Assinatura:',
  integration: 'Banco / integração',
  selectIntegration: 'Selecione a integração',
  identifiersHelp:
    'Informe o cliente para consultar todas as cobranças ou uma assinatura para limitar a consulta. Se informar só a assinatura, localizamos o cliente no banco.',
  openConversation:
    'Para enviar, abra a conversa de WhatsApp do contato e use Cobranças do contato na Central do cliente.',
  windowHelp:
    'O envio passa por confirmação e precisa de uma janela de atendimento aberta no WhatsApp. Fora dela, use um modelo aprovado na conversa.',
  sendDisabled: 'O envio de segunda via está desligado na integração do banco.',
  empty: 'Nenhuma cobrança encontrada nesta página.',
  due: 'Vencimento:',
  openPayment: 'Abrir boleto / pagamento',
  page: 'Página',
  confirmationTitle: 'Enviar cobrança pelo WhatsApp',
  removalTitle: 'Remover vínculo bancário?',
};
